import ClientModule from "@gqlapp/module-client-react";
import storage from "@xem/storage";
import i18n from "@xem/i18n-client-react";
import Block from "@xem/entity-client-react";
import PageNotFound from "@xem/page-not-found";
import Router from "@xem/router-client-react";
import Modules from "./modules";
const Base = new ClientModule(storage, i18n, Block, Modules, PageNotFound, Router);
export default Base;
